module.exports = __webpack_public_path__ + "media/images/header-345b0c22.jpg";